import { observer } from 'mobx-react-lite'
import { RadioOptions } from 'shared/ui/Radio'
import { type DeleteSimpleActionStore } from '../DeleteSimpleActionStore.tsx'

export const Content = observer(({ store }: { store: DeleteSimpleActionStore }) => {
  const { isNextDelete, setNextDelete } = store
  return (
    <RadioOptions
      options={[
        {
          id: 'only',
          value: 'only',
          text: 'Delete this action only',
        },
        {
          id: 'following',
          value: 'following',
          text: 'Delete this action and all following actions',
        },
      ]}
      active={isNextDelete ? 'following' : 'only'}
      onChange={(id: string) => setNextDelete(id === 'following')}
    />
  )
})
